import FolderItem from 'modules/documents/components/DocumentsAndFolders/FoldersList/FolderItem'
import GridList from 'modules/documents/components/GridList'
import FoldersSkeleton from 'modules/documents/components/GridList/Skeleton'
import { useGetEmployeeFolder } from 'modules/documents/hooks/useGetEmployeeFolder'
import { useGetFolders } from 'modules/documents/hooks/useGetFolders'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { getSubfoldersCountForSkeletons, isCompanySpace } from 'modules/documents/lib/Documents'
import { sortFoldersByName } from 'modules/documents/lib/Folders'
import { SPACE } from 'modules/documents/lib/constants'

import { filterByLegalEntityCountry, showByLegalEntity } from './legalEntityFolderFilter'

interface Props {
  employeeId?: string
  legalEntityCountry?: string
  parentFolderId?: string
  space: SPACE
  readonly: boolean
  onFolderSelected: (folder: Folder) => void
}

const FoldersList = ({
  employeeId,
  legalEntityCountry,
  parentFolderId,
  space,
  readonly,
  onFolderSelected,
}: Props) => {
  const isCompanySpaceCheck = isCompanySpace(space)
  const numberOfSubfolders = getSubfoldersCountForSkeletons(parentFolderId)

  const { loading: loadingFolders, folders } = useGetFolders(
    {
      parentFolderId,
      rootFolders: !parentFolderId,
      space,
      employeeId,
      withCounters: true,
    },
    'no-cache'
  )

  const { loading: loadingEmployeeFolders, employeeFolders } = useGetEmployeeFolder(
    [employeeId].filter(Boolean)
  )

  let filteredFolders = folders

  if (!parentFolderId && !isCompanySpaceCheck) {
    filteredFolders = folders.filter((folder) =>
      employeeFolders?.some((employeeFolder) => employeeFolder?.folderId === folder.id)
    )
  }

  filteredFolders =
    employeeId && legalEntityCountry
      ? filteredFolders.filter(({ identifier }) => {
          if (!identifier || !showByLegalEntity(identifier)) return true
          return filterByLegalEntityCountry(legalEntityCountry, identifier)
        })
      : filteredFolders
  const sortedFolders = sortFoldersByName(filteredFolders)

  const loading = loadingFolders || loadingEmployeeFolders

  return (
    <>
      {loading && numberOfSubfolders > 0 && (
        <FoldersSkeleton numberOfSkeletons={numberOfSubfolders} />
      )}
      {!loading && (
        <GridList.List>
          {sortedFolders.map((folder) => (
            <FolderItem
              key={folder.id}
              employeeId={employeeId}
              parentFolderId={parentFolderId}
              folder={folder}
              readonly={readonly}
              onFolderSelected={onFolderSelected}
            />
          ))}
        </GridList.List>
      )}
    </>
  )
}

export default FoldersList
